import { Injector, Injectable, Inject } from '@angular/core';
import { APP_SETTINGS} from '../../../modules/ng-express-engine/tokens';


@Injectable()
export class UtilService{
    private preloadService;
    private r;
    constructor(
        @Inject(APP_SETTINGS) private settings: Object,
        private injector: Injector
    ){
    }

    public toTitleCase (str) {
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    }

    public rowDataKey (row: Object, key: string): string {
        if (row['get_url'] == null || row['get_url'].length < 10){
            const slug = (row['slug'] == null) ? row['identifier'] : row['slug'];
            return key + "/" + slug;
        }
        else{
            return row['get_url'].replace(this.settings['DATA_API_ENDPOINT'], "");
        }
    }


}





// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/util.service.ts